import { InfoCircleOutlined, PlusOutlined } from "@ant-design/icons";
import { Card, Row, Col, Button, Typography, Input, Popover } from "antd";
import InfoCardComponent from "../../../components/InfoCardComponent";
import { StyleSheet } from "../../../StyleSheet";
import { Key, useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import { AlertSliceInterface, clearAlert, setAlert, showAlert } from "../../../stores/slices/alertSlice";
import { AppDispatch } from "../../../stores/store";
import { RequestAsociarContrato } from "../../../types/common";
import { images } from "../../../routes/ImageRoutes";
const { Text } = Typography;

interface errorFieldsProps {
    suscriptor: string,
    fullName: string,
    extNumber: string
}

interface Props {
    showElement: Key | undefined;
    handlePress: Function;
    addContract: Function;
}
const AddContract = (props: Props) => {
    const { showElement, handlePress, addContract } = props;

    const emptyErrorFields: errorFieldsProps = {
        suscriptor: "",
        fullName: "",
        extNumber: ""
    }
    const [suscriptorNew, setSuscriptorNew] = useState<string>("");
    const [fullNameNew, setFullNameNew] = useState<string>("");
    const [extNumberNew, setExtNumberNew] = useState<string>("");
    const [errorsEmptyFields, setErrorsEmptyFields] = useState<errorFieldsProps>(emptyErrorFields);

    const dispatch = useDispatch<AppDispatch>();

    const handleDispatchAlertModal = useCallback(() => {
        dispatch(showAlert(false));
        dispatch(clearAlert());
    }, [dispatch]);

    // Manejador para el alert
    const openAlertModal = useCallback((option: AlertSliceInterface) => {
        dispatch(setAlert({
            show: option.show,
            type: option.type as "INFO" | "SUCCESS" | "ERROR",
            title: option.title,
            message: option.message,
            onFinalize: option.onFinalize
        }));
    }, [dispatch]);

    const validate = () => {
        let error = "";
        let errorFields: errorFieldsProps = {
            suscriptor: "",
            fullName: "",
            extNumber: ""
        }

        if (suscriptorNew.length < 10) {
            let message = "El campo Número de Suscriptor debe tener 10 dígitos.\n";
            error += message;
            errorFields.suscriptor = message;
        }
        if (!suscriptorNew) {
            let message = "El campo Número de Suscriptor está vacío.\n";
            error += message;
            errorFields.suscriptor = message;
        }
        if (!fullNameNew) {
            let message = "El campo Nombre del Suscriptor está vacío.\n";
            error += message;
            errorFields.fullName = message;
        }
        if (!extNumberNew) {
            let message = "El campo Número Exterior está vacío.\n";
            error += message;
            errorFields.extNumber = message;
        }

        setErrorsEmptyFields(errorFields);
        if (error !== "") {
            let dispatchAlert: AlertSliceInterface = {
                show: true,
                type: "ERROR",
                title: "¡Estimado Usuario!",
                message: error,
                onFinalize: () => handleDispatchAlertModal()
            }
            openAlertModal(dispatchAlert);
        }

        // si no hubo errores, procede al siguiente paso
        if (error === "") {
            let objAddContract: RequestAsociarContrato = {
                sucursalAsociar: suscriptorNew.substring(0, 3),
                suscriptorAsociar: suscriptorNew.substring(3, 10),
                Nombre: fullNameNew,
                NumeroExterior: extNumberNew
            }
            addContract(objAddContract)
        }
    }

    const handleChangeCliente = (value: string) => {
        errorsEmptyFields.suscriptor = "";
        setSuscriptorNew(value.replace(/[^0-9]/g, ""));
    }

    const handleChangeFullName = (value: string) => {
        errorsEmptyFields.fullName = "";
        setFullNameNew(value);
    }

    const handleChangeExtNum = (value: string) => {
        errorsEmptyFields.extNumber = "";
        setExtNumberNew(value);
    }

    return (
        <Card style={styles.cardStyles}>
            <Row style={{ cursor: 'pointer' }} onClick={() => handlePress("addContract")}>
                <Col span={20} style={styles.titleContainer}>
                    <h3 style={styles.addContract}>{"Añadir contrato"}</h3>
                </Col>
                <Col span={4} style={styles.colView}>
                    <PlusOutlined style={styles.iconStyles} />
                </Col>
            </Row>
            {
                showElement === "addContract" ?
                    <div >
                        <div style={{ padding: "15px 0px 20px 0px" }}>
                            <InfoCardComponent
                                title="Aquí puede vincular a su cuenta principal contratos adicionales"
                                description={"Nombre y número exterior deben coincidir con los datos que aparecen en el estado de cuenta."}
                            />
                        </div>
                        <Row gutter={[30, 16]}>
                            <Col xs={24} xl={12}>
                                <Text style={styles.inputTitle}>Número de Suscriptor</Text>
                                <Input
                                    placeholder="Número de suscriptor"
                                    value={suscriptorNew}
                                    style={styles.inputText}
                                    onChange={(event) => handleChangeCliente(event.target.value)}
                                    status={errorsEmptyFields.suscriptor ? "error" : ""}
                                    maxLength={10}
                                    suffix={
                                        <Popover
                                            trigger="click"
                                            content={
                                                <img style={styles.imageStyle} src={images.tooltipSuscriptor} alt={"suscriptor-number"} />
                                            }
                                            overlayInnerStyle={{ padding: 2 }}>
                                            <InfoCircleOutlined style={styles.iconInfo} />
                                        </Popover>
                                    }
                                />
                                {<Text type="danger" style={styles.emptyFieldError}>{errorsEmptyFields.suscriptor ? errorsEmptyFields.suscriptor : null}</Text>}
                            </Col>
                            <Col xs={24} xl={12}>
                                <Text style={styles.inputTitle}>Nombre del Suscriptor</Text>
                                <Input
                                    placeholder="Nombre de suscriptor"
                                    value={fullNameNew}
                                    style={styles.inputText}
                                    onChange={(event) => handleChangeFullName(event.target.value)}
                                    status={errorsEmptyFields.fullName ? "error" : ""}
                                    suffix={
                                        <Popover
                                            trigger="click"
                                            content={
                                                <img style={styles.imageStyle} src={images.tooltipName} alt={"suscriptor-name"} />
                                            }
                                            overlayInnerStyle={{ padding: 2 }}>
                                            <InfoCircleOutlined style={styles.iconInfo} />
                                        </Popover>
                                    }
                                />
                                {<Text type="danger" style={styles.emptyFieldError}>{errorsEmptyFields.fullName ? errorsEmptyFields.fullName : ""}</Text>}
                            </Col>
                            <Col xs={24} xl={12}>
                                <Text style={styles.inputTitle}>Número Exterior</Text>
                                <Input
                                    placeholder="Número exterior"
                                    value={extNumberNew}
                                    style={styles.inputText}
                                    onChange={(event) => handleChangeExtNum(event.target.value)}
                                    status={errorsEmptyFields.extNumber ? "error" : ""}
                                    suffix={
                                        <Popover
                                            trigger="click"
                                            content={
                                                <img style={styles.imageStyle} src={images.tooltipExtNum} alt={"suscriptor-ext-number"} />
                                            }
                                            overlayInnerStyle={{ padding: 2 }}>
                                            <InfoCircleOutlined style={styles.iconInfo} />
                                        </Popover>
                                    }
                                />
                                {<Text type="danger" style={styles.emptyFieldError}>{errorsEmptyFields.extNumber ? errorsEmptyFields.extNumber : null}</Text>}
                            </Col>
                        </Row>
                        <div style={styles.containerButtonAdd}>
                            <Button
                                size='large'
                                style={styles.buttonPrimary}
                                onClick={validate}
                            >
                                {"Registrar"}
                            </Button>
                        </div>
                    </div>
                    : null
            }
        </Card>
    );
};
const styles = StyleSheet.create({
    cardStyles: {
        marginBottom: 15,
        boxShadow: "0px 0px 8px #00000029",
        borderRadius: 15,
        width: "70%",
    },
    titleContainer: {
        display: "flex",
        flexDirection: 'column',
    },
    addContract: {
        fontWeight: 600,
        color: "#757982",
        fontSize: 17,
    },
    colView: {
        display: 'flex',
        justifyContent: 'flex-end'
    },
    inputTitle: {
        color: "#0055c2",
        fontWeight: 600,
        fontSize: 12
    },
    inputText: {
        marginTop: 15,
        color: "#000000",
        borderColor: '#000000',
        fontSize: 12
    },
    emptyFieldError: {
        fontSize: 11
    },
    containerButtonAdd: {
        display: "flex",
        justifyContent: 'flex-end',
        marginTop: 20
    },
    buttonPrimary: {
        backgroundColor: '#0055c2',
        borderRadius: 30,
        color: 'white',
        border: "none",
        padding: "5px 30px",
        height: 35
    },
    iconStyles: {
        fontSize: 20,
        color: "#767a82"
    },
    imageStyle: {
        width: 200,
        height: 97,
    },
    iconInfo: {
        color: 'rgba(0,0,0,.45)'
    }
});
export default AddContract;
